<template>
  <b-modal
    id="config-update-modal"
    :visible="shallShowModal"
    centered
    footer-class="d-flex justify-content-between"
    body-class="px-2"
    modal-class="modal-sticky"
    size="lg"
    no-close-on-backdrop
    static
    @change="(val) => $emit('update:shall-show-modal', val)"
  >
    <!-- Modal Header -->
    <template #modal-header>
      <h5 class="modal-title"> 编辑数据组数据 </h5>
      <div class="modal-actions">
        <feather-icon
          icon="XIcon"
          class="ml-1 cursor-pointer"
          @click="$emit('update:shall-show-modal', false)"
        />
      </div>
    </template>

    <!-- Modal Footer -->
    <template #modal-footer>
      <div>
        <b-button
          variant="outline-primary"
          class="cursor-pointer mr-1"
          @click="reset"
        >
          重置
        </b-button>
        <b-button
          variant="outline-secondary"
          class="cursor-pointer ml-0"
          @click="$emit('update:shall-show-modal', false)"
        >
          取消
        </b-button>
      </div>
      <b-button
        v-ripple.400="'rgba(113, 102, 240, 0.15)'"
        variant="primary"
        class="mb-1 mb-sm-0"
        @click="updateForm"
      >
        确定
      </b-button>
    </template>

    <validation-observer ref="refFormObserver">
      <b-form>
        <!-- 自定义表单项渲染 -->
        <b-row>
          <b-col
            :cols="item.cols ? item.cols : 12"
            v-for="(item,index) in headerArray"
            :key="index"
            v-if="!item.display"
          >
            <validation-provider
              #default="{ errors }"
              :name="item.label"
              :rules="`${item.rules ? item.rules : ''}`"
            >
              <!-- input -->
              <b-form-group :label="item.label" label-cols="auto"  v-if="item.component === 'input'">
                <!-- TODO: required vuexy 模板貌似不支持 -->
                <b-form-input
                  v-model="formData[item.param]"
                  :state="errors.length > 0 ? false:null"
                  :disabled="item.disabled ? item.disabled : false"
                  :form="item.form"
                  :autofocus="item.autofocus ? item.autofocus : false"
                  :size="item.size"
                  :type="item.type ? item.type : 'text'"
                  :trim="item.trim ? item.trim : true"
                  :autocomplete="item.autocomplete ? item.autocomplete : 'on'"
                  :placeholder="item.placeholder"
                  :formatter="item.placeholder"
                  :number="item.number ? item.number : false"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>

              <!-- radio -->
              <b-form-group :label="item.label" label-cols="auto" v-if="item.component === 'radio'">
                <b-form-radio-group
                  v-model="formData[item.param]"
                  :state="errors.length > 0 ? false:null"
                  :options="item.options"
                  class="col-form-label"
                  value-field="value"
                  text-field="text"
                  disabled-field="disabled"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>

              <!-- checkbox -->
              <b-form-group :label="item.label" label-cols="auto" v-if="item.component === 'checkbox'">
                <b-form-checkbox-group
                  v-model="formData[item.param]"
                  :state="errors.length > 0 ? false:null"
                  :options="item.options"
                  class="col-form-label"
                  value-field="value"
                  text-field="text"
                  disabled-field="disabled"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>


              <!-- select -->
              <b-form-group :label="item.label" label-cols="auto" v-if="item.component === 'select'" :state="errors.length > 0 ? false:null">
                <v-select
                  v-model="formData[item.param]"
                  :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                  :label="item.selectLabel ? item.selectLabel : 'text'"
                  :options="item.options"
                  :multiple="item.multiple ? item.multiple : false"
                  :reduce="val => item.valueTitle ? val[item.valueTitle]: val.value"
                >
                  <template v-slot:no-options>没有更多信息</template>
                </v-select>
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>

              <!-- textarea -->
              <!-- :max-rows="item.maxRows ? item.maxRows : 3" -->
              <b-form-group :label="item.label" label-cols="auto" v-if="item.component === 'textarea'">
                <b-form-textarea
                  v-model="formData[item.param]"
                  :state="errors.length > 0 ? false:null"
                  :disabled="item.disabled ? item.disabled : false"
                  :form="item.form"
                  :autofocus="item.autofocus ? item.autofocus : false"
                  :size="item.size"
                  :trim="item.trim ? item.trim : true"
                  :autocomplete="item.autocomplete ? item.autocomplete : 'on'"
                  :placeholder="item.placeholder"
                  :formatter="item.placeholder"
                  :number="item.number ? item.number : false"
                  :rows="item.rows ? item.rows : 2"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>

            </validation-provider>
          </b-col>
        </b-row>

        <b-row>
          <!-- sort -->
          <b-col cols="6">
            <validation-provider name="配置排序" #default="{ errors }" rules="required">
              <b-form-group label="配置排序" label-for="group-data-sort" label-cols="auto">
                <b-form-input
                  id="group-data-sort"
                  :state="errors.length > 0 ? false:null"
                  v-model="formData.sort" trim
                  number type="number"
                  placeholder="配置排序"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
          <!-- status -->
          <b-col cols="6">
            <validation-provider name="配置状态" #default="{ errors }" rules="required">
              <b-form-group label="配置状态" label-for="group-data-status" :state="errors.length > 0 ? false:null" label-cols="auto">
                <b-form-radio-group id="group-data-status" class="col-form-label" v-model="formData.status" :options="statusOptions" />
                <small class="text-danger">{{ errors[0] }}</small>
              </b-form-group>
            </validation-provider>
          </b-col>
        </b-row>
      </b-form>
    </validation-observer>
  </b-modal>
</template>

<script>
import { ref, watch } from '@vue/composition-api'
import vSelect from 'vue-select'
import Ripple from 'vue-ripple-directive'
import { useToast } from 'vue-toastification/composition'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

export default {
  directives: {
    Ripple,
  },
  components: {
    vSelect,
    ValidationProvider,
    ValidationObserver,
  },
  model: {
    prop: 'shallShowModal',
    event: 'update:shall-show-modal',
  },
  props: {
    shallShowModal: {
      type: Boolean,
      required: true,
    },
    headerArray: {
      type: Array,
      required: true,
    },
    info: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    /* 必要组件加载区域 */
    // 消息提醒组件
    const toast = useToast()

    /* 组件页面数据准备区域，包括表单，下拉选择项，数据整理操作等 */
    // 状态参数
    const statusOptions = [
      { text: '启用', value: true },
      { text: '禁用', value: false },
    ]
    // 自定义字段
    const customerFieldsParams = ref([])

    // 表单验证dom对象
    const refFormObserver = ref(null)
    // 表单数据项
    const formData = ref({ id: 0, sort: 0, status: true })
    // 表单数据清空函数
    const resetFormData = () => {
      formData.value = { id: 0, sort: 0, status: true }
      refFormObserver.value.reset()
    }
    // 重置内容
    const reset = () => {
      formData.value = JSON.parse(JSON.stringify(props.info))
      refFormObserver.value.reset()
    }

    /* 接口调用区域 */

    // 保存 处理编辑
    const updateForm = () => {
      refFormObserver.value.validate().then(success => {
        if (success) {
          emit('up-ok', formData.value)
          emit('update:shall-show-modal', false)
        }
        // else {
        //   toast({
        //     component: ToastificationContent,
        //     props: { title: '验证异常', text: '发生未知验证错误,请联系管理员', icon: 'AlertTriangleIcon', variant: 'danger' },
        //   })
        // }
      })
    }

    /* 组件内部逻辑处理，生命周期问题处理区域 */

    // 编辑窗口关闭，清空表单并刷新验证，窗口打开时候，获取传递的参数，并且请求接口回去最新的分类列表
    watch(
      () => props.shallShowModal,
      val => {
        val ? formData.value = JSON.parse(JSON.stringify(props.info)) : resetFormData()
      },
    )

    return {
      formData,
      statusOptions,
      refFormObserver,
      updateForm,
      reset,

      required,
    }
  },
}
</script>
